import { CAREER_START_YEAR, SENIOR_PROMOTION_YEAR } from './experience';

/**
 * Stops of the guided map tour shown inside the Metamedia project modal.
 *
 * The tour zooms out step by step — desk, city, country — to show how the
 * scope of the work grew. Every fact here already appears elsewhere on the
 * site, so nothing has to be kept in sync by hand except this file.
 */
/** Bounding box of Thailand, used to fit the whole country in view */
export const THAILAND_BOUND = {
  minLon: 97.34,
  minLat: 5.61,
  maxLon: 105.64,
  maxLat: 20.47,
};

export const TOUR_STOPS = [
  {
    id: 'joined',
    year: String(CAREER_START_YEAR),
    label: 'Jun 2021',
    title: 'Joined Metamedia Technology',
    place: 'Bangkok, Thailand',
    summary:
      'Started as a Software Developer, working across the whole web stack from UI to services.',
    stack: ['Vue.js', 'Nuxt.js', 'PHP'],
    location: { lat: 13.722642, lon: 100.529316 },
    zoom: 16,
    // Label of the shared pin at this location
    pinLabel: 'Metamedia',
  },
  {
    id: 'longdo-map',
    year: 'GIS',
    label: '2021 — Present',
    title: 'Longdo Map Platform',
    place: 'Bangkok coverage',
    summary:
      "Building on the company's GIS product — the JavaScript map API and the backend services behind it.",
    stack: ['JavaScript', 'Go', 'Node.js'],
    location: { lat: 13.747371, lon: 100.609195 },
    zoom: 10,
    // Province boundary drawn while this stop is active
    province: { code: '10', title: 'Bangkok' },
  },
  {
    id: 'nationwide',
    year: 'Scale',
    label: 'Nationwide',
    title: 'Full-Stack & Test Automation',
    place: 'Thailand',
    summary:
      'Shipping map features used across the country, kept stable with Cypress end-to-end and Vitest unit tests.',
    stack: ['Cypress', 'Vitest', 'Keycloak', 'Git'],
    location: { lat: 14.2, lon: 101.0 },
    zoom: 6,
  },
  {
    id: 'senior',
    year: String(SENIOR_PROMOTION_YEAR),
    label: `${SENIOR_PROMOTION_YEAR} — Present`,
    title: 'Promoted to Senior Software Developer',
    place: 'Metamedia HQ, Bangkok',
    summary:
      'Now leading feature work end to end — architecture and code review alongside mentoring on the team.',
    stack: ['Architecture', 'Code Review', 'Mentoring'],
    location: { lat: 13.747371, lon: 100.609195 },
    // Closing shot fits the whole country instead of a fixed zoom level
    bound: THAILAND_BOUND,
    milestone: true,
  },
];

/** How long each stop is held when the tour plays automatically (ms) */
export const STOP_DURATION = 6500;

/** Camera flight time between stops (ms) */
export const FLIGHT_DURATION = 1800;
